import { FrameWrapper } from "./ExercisesStyle"
import ReplaceitExercise from "./01_replaceit/ReplaceitExercise"
import FixitExercise from "./02_fixit/FixitExercise"
import FillitinExercise from "./03_fillitin/FillitinExercise"

const Exercises = ( {lessonNumber} ) => {
  return (
    <FrameWrapper>
      <ReplaceitExercise lessonNumber={lessonNumber}/>
      <FixitExercise lessonNumber={lessonNumber}/>
      <FillitinExercise lessonNumber={lessonNumber}/>
    </FrameWrapper>
  )
}

export default Exercises